import React, { createContext, useState } from "react";
import PropTypes from "prop-types";

export const ConfirmContext = createContext();

const ConfirmContextProvider = ({ children }) => {
  const [confirm, setConfirm] = useState({
    isOpen: false,
    proceed: null,
    cancel: null,
    approveText: "Yes",
    rejectText: "No",
    title: "",
    description: "",
  });

  return (
    <ConfirmContext.Provider value={[confirm, setConfirm]}>{children}</ConfirmContext.Provider>
  );
};

ConfirmContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default ConfirmContextProvider;
